import { heroLead, heroSideCards, statItems } from '@/mocks/homeData';

export default function HeroGrid() {
  return (
    <section id="hero" className="w-full bg-background-50 pb-10 pt-8 md:pb-14 md:pt-12">
      <div className="mx-auto w-full max-w-[1360px] px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-6 items-center gap-1.5 rounded-full bg-primary-100 px-2.5 text-xs font-bold text-primary-700">
                <i className="ri-flashlight-fill" />
                今日六点
              </span>
              <span className="text-xs text-foreground-500">2026.09.10 · 星期四</span>
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight tracking-tight text-foreground-950 md:text-4xl">
              六点前的瓜，和六点刚出的事
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              黑料六点今日六点准时更新重点摘要，所有片段按时间顺序排在一起，顺着往下读就能把今天的进展看完整。
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <span className="flex h-14 w-14 flex-col items-center justify-center rounded-lg border border-background-200 bg-background-100 leading-none">
              <span className="font-heading text-lg font-black text-primary-600">18</span>
              <span className="mt-0.5 text-[10px] text-foreground-500">点整</span>
            </span>
            <span className="flex h-14 w-14 flex-col items-center justify-center rounded-lg border border-background-200 bg-background-100 leading-none">
              <span className="font-heading text-lg font-black text-foreground-900">37</span>
              <span className="mt-0.5 text-[10px] text-foreground-500">条新</span>
            </span>
          </div>
        </div>

        {/* 多卡并列首屏 */}
        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-[1.55fr_1fr]">
          <article
            className="group relative flex min-h-[320px] cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-foreground-950 md:min-h-[420px] lg:min-h-[460px]"
          >
            <img
              src={heroLead.cover}
              alt="黑料六点今日六点主推：六点前最后一批瓜集中放出"
              title="黑料六点今日六点主推线索合集"
              className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/55 to-foreground-950/10" />
            <div className="relative z-10 flex w-full flex-col justify-between p-5 md:p-7">
              <div className="flex items-center gap-2">
                <span className="flex h-6 items-center gap-1.5 rounded-md bg-primary-500 px-2.5 text-xs font-bold text-background-50">
                  <i className="ri-fire-fill" />
                  {heroLead.tag}
                </span>
                <span className="flex h-6 items-center gap-1 rounded-md border border-background-50/30 bg-foreground-950/40 px-2 text-xs font-medium text-background-50 backdrop-blur">
                  <span className="pulse-dot flex h-1.5 w-1.5 rounded-full bg-accent-400" />
                  {heroLead.stamp}
                </span>
                <span className="text-xs text-background-200">{heroLead.time}</span>
              </div>

              <div className="mt-auto pt-16">
                <h3 className="font-heading text-xl font-black leading-snug text-background-50 md:text-3xl">
                  {heroLead.title}
                </h3>
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-200 md:text-[15px]">
                  {heroLead.excerpt}
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-background-200">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-sm" />
                    {heroLead.comments} 条评论
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-eye-line text-sm" />
                    {heroLead.heat} 阅读
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-bookmark-line text-sm" />
                    {heroLead.follows} 人跟进
                  </span>
                  <span className="ml-auto flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-3 py-1.5 font-semibold text-foreground-950">
                    读全文
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </div>
          </article>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-1">
            {heroSideCards.map((card) => (
              <article
                key={card.title}
                className="group flex cursor-pointer gap-3 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:gap-4"
              >
                <div className="relative h-[86px] w-[118px] shrink-0 overflow-hidden rounded-md bg-background-200 md:h-[104px] md:w-[150px]">
                  <img
                    src={card.cover}
                    alt={`黑料六点每日准点 - ${card.title}`}
                    title={`黑料六点每日准点 ${card.tag} 卡片`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex items-center gap-2">
                    <span className="rounded-sm bg-accent-100 px-1.5 py-0.5 text-[11px] font-bold text-accent-900">
                      {card.tag}
                    </span>
                    <span className="text-[11px] text-foreground-500">{card.time}</span>
                  </div>
                  <h3 className="mt-1.5 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-[15px]">
                    {card.title}
                  </h3>
                  <div className="mt-auto flex items-center gap-3 pt-2 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line" />
                      {card.comments}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line" />
                      {card.heat}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* 数据条 */}
        <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-4">
          {statItems.map((stat, index) => (
            <div
              key={stat.label}
              className={`flex items-center justify-between rounded-lg border px-4 py-3.5 ${
                index === 1
                  ? 'border-accent-300 bg-accent-50'
                  : 'border-background-200 bg-background-100'
              }`}
            >
              <span className="text-xs font-medium text-foreground-600">{stat.label}</span>
              <span className="flex items-baseline gap-1">
                <span className="font-heading text-lg font-black text-foreground-950">
                  {stat.value}
                </span>
                <span className="text-[11px] text-foreground-500">{stat.unit}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}